import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Notificaion from '../AppsAdoptionNotification'
import { space, Image } from '@ticketswap/solar'

const ImageContainer = styled.div`
  position: relative;
  display: block;
`

const StyledNotification = styled(Notificaion)`
  position: absolute;
  bottom: ${space[32]};
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
`

const AppsNotification = ({ image, t, eventName }) => (
  <ImageContainer>
    <Image src={image} />
    <StyledNotification t={t} eventName={eventName} />
  </ImageContainer>
)

AppsNotification.propTypes = {
  image: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default AppsNotification
